import type { RecordObject } from "@/profitability/records/objects";
import type { ReportDates, ReportRow } from "@/profitability/types";
import { useShowSource } from "./source-context";

/**
 * Undefined where the page offers none, the dataset neither cites its rows
 * nor names a source, or the run is not known.
 */
export const useRecordSource = (
  object: RecordObject | undefined,
  row: ReportRow | undefined,
  /**
   * The run the row is from: undefined for the page's period, null when not
   * known (a row from an earlier period whose run is lost), which offers none.
   */
  runId?: string | null,
  /** That run's dates, where a figure missing from it is uploaded. */
  dates?: ReportDates | null,
) => {
  const source = useShowSource();
  if (!source || !object || !row || runId === null) return undefined;
  if (!source.available(object.dataset)) return undefined;
  return (column?: string | null) =>
    source.open({ object, row, column: column ?? null, runId, dates });
};
